module.exports = __webpack_public_path__ + "static/media/logo-operadora.ed30c29e.jpg";